import NavigationComponent from './Navigation';
import { RouteLink } from './RouteLink';

export default NavigationComponent;
export { RouteLink };
